import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Btn, Modal, Input, Textarea, Select, Toggle, ImageField } from "./AdminUI";
import { Plus, Edit2, Trash2, Lock } from "lucide-react";

const CATS = ["Company Profile", "Architecture Services", "Interior Services", "Construction Packages", "Selected Projects", "Other"];
const EMPTY = { title: "", description: "", pdf_url: "", thumbnail: "", category: "Company Profile", gated: false, active: true, order: 0 };

export default function BrochuresAdmin() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/brochures/admin/all").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!editing.title.trim()) return alert("Title required");
    if (editing.id) await api.put(`/brochures/admin/${editing.id}`, editing);
    else await api.post("/brochures/admin", editing);
    setEditing(null); load();
  };
  const del = async (id) => { if (window.confirm("Delete brochure?")) { await api.delete(`/brochures/admin/${id}`); load(); } };
  const setF = (k, v) => setEditing({ ...editing, [k]: v });

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-ink">Brochures / Downloads <span className="text-muted text-base">({items.length})</span></h1>
        <Btn onClick={() => setEditing({ ...EMPTY })} data-testid="add-brochure-btn"><Plus size={16} /> Add Brochure</Btn>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((b) => (
          <div key={b.id} className="rounded-xl2 bg-white border border-line overflow-hidden">
            {b.thumbnail && <div className="relative aspect-[16/10] bg-sand"><img src={b.thumbnail} alt="" className="img-cover" /></div>}
            <div className="p-4">
              <div className="flex items-center gap-2"><span className="text-[10px] text-gold font-bold uppercase">{b.category}</span>{b.gated && <span className="text-[10px] bg-beige text-ink px-2 py-0.5 rounded-full flex items-center gap-1"><Lock size={9} /> Gated</span>}{!b.active && <span className="text-[10px] bg-ink/80 text-white px-2 py-0.5 rounded-full">Hidden</span>}</div>
              <h3 className="font-bold text-ink text-sm mt-1">{b.title}</h3>
              <div className="flex gap-2 mt-3"><Btn variant="outline" onClick={() => setEditing({ ...EMPTY, ...b })}><Edit2 size={14} /> Edit</Btn><Btn variant="danger" onClick={() => del(b.id)}><Trash2 size={14} /></Btn></div>
            </div>
          </div>
        ))}
      </div>
      {editing && (
        <Modal title={editing.id ? "Edit Brochure" : "Add Brochure"} onClose={() => setEditing(null)}>
          <div className="space-y-4">
            <Input label="Title *" value={editing.title} onChange={(v) => setF("title", v)} />
            <Textarea label="Description" value={editing.description} onChange={(v) => setF("description", v)} />
            <Select label="Category" value={editing.category} onChange={(v) => setF("category", v)} options={CATS} />
            <Input label="PDF URL (upload the PDF to storage and paste its link)" value={editing.pdf_url} onChange={(v) => setF("pdf_url", v)} />
            <ImageField label="Thumbnail Image" value={editing.thumbnail} onChange={(v) => setF("thumbnail", v)} folder="gnons/settings/" />
            <Input label="Display Order" type="number" value={editing.order} onChange={(v) => setF("order", parseInt(v) || 0)} />
            <div className="grid grid-cols-2 gap-3">
              <Toggle label="Lead-Gated (Name+Mobile)" checked={editing.gated} onChange={(v) => setF("gated", v)} />
              <Toggle label="Active" checked={editing.active} onChange={(v) => setF("active", v)} />
            </div>
          </div>
          <div className="flex justify-end gap-3 mt-6"><Btn variant="outline" onClick={() => setEditing(null)}>Cancel</Btn><Btn onClick={save} data-testid="save-brochure-btn">Save</Btn></div>
        </Modal>
      )}
    </div>
  );
}
